<template>
	<div class="mango-buttoned-input">
		<input type="text" v-model="model" placeholder="Slevový kód" @keyup="handleKeyUp">
		<button type="button" @click="$emit('submit')">{{ buttonTitle }}</button>
	</div>
</template>

<script>
	export default {
		name: "MangoButtonedInput",
		props: {
			value: String,
			buttonTitle: String
		},
		computed: {
			model: {
				get() {
					return this.value
				},
				set(value) {
					this.$emit("input", value)
				}
			}
		},
		methods: {
			handleKeyUp(e) {
				if (e.code === "Enter") this.$emit("submit")
			}
		}
	}
</script>

<style lang="scss">
	.mango-buttoned-input {
		display: flex;
		width: 100%;

		input {
			width: 0;
			flex-grow: 1;
			display: block;
			border-radius: 4px 0 0 4px;
			background-color: rgba(255, 255, 255, 0.21);
			color: rgba(255, 255, 255, 0.8);
			padding: 0 10px;
			font-weight: 300;
			line-height: 40px;
			border: 1px solid rgba(255, 255, 255, 0.2);
			border-right: none;

			&:hover {
				border: 1px solid rgba(255, 255, 255, 0.4);
				border-right: none;
			}

			&:focus {
				border: 1px solid rgba(255, 255, 255, 0.6);
				border-right: none;
				outline: none;
			}

			&::placeholder {
				color: rgba(255, 255, 255, 0.3);
			}
		}

		button {
			cursor: pointer;
			display: block;
			font-size: 1rem;
			border: none;
			background-color: #ef904e;
			border-radius: 0 4px 4px 0;
			padding: 0 20px;
			line-height: 40px;
			color: rgba(255, 255, 255, 0.75);

			&:hover {
				background-color: #d07a46;
			}
		}
	}
</style>
